import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const SvgComponent = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: SVGComponentProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <path
      d="M12.2344 6.51594L12.1993 6.48025L12.2344 6.51594C13.3226 5.44815 13.3225 3.71049 12.2342 2.64278C11.6902 2.109 10.9759 1.84231 10.2617 1.84238C9.54779 1.84245 8.83313 2.10906 8.28916 2.64278L4.02662 6.82487C3.7066 7.1388 3.53005 7.55666 3.53 8.00106C3.53 8.44549 3.70648 8.86333 4.02655 9.17736L4.06157 9.14167L4.02656 9.17736C4.68706 9.82531 5.76127 9.82529 6.42164 9.17724C6.42164 9.17724 6.42164 9.17724 6.42164 9.17724L9.20918 6.44245C9.44317 6.21291 9.44316 5.8403 9.20923 5.61072C8.97579 5.38161 8.59766 5.3817 8.36419 5.61071L8.36418 5.61071L5.57662 8.34552C5.38238 8.53609 5.06589 8.53613 4.87164 8.34557C4.77762 8.25332 4.7261 8.13111 4.7261 8.00109C4.7261 7.87107 4.77759 7.7489 4.87165 7.65661L9.1342 3.47454C9.7558 2.86476 10.7676 2.86468 11.3892 3.4745C12.0102 4.08382 12.0102 5.07495 11.3893 5.68427L6.73912 10.2465C5.69014 11.2756 3.98295 11.2756 2.93413 10.2465L2.89912 10.2822L2.93413 10.2465C2.42604 9.74806 2.1465 9.08578 2.1465 8.3813C2.1465 7.67683 2.42606 7.01455 2.93413 6.51608L7.58423 1.95373C7.8182 1.72416 7.81819 1.35157 7.58419 1.12199C7.46735 1.00733 7.31431 0.95021 7.16168 0.95021C7.009 0.95021 6.85598 1.00741 6.73915 1.12198L6.73914 1.12199L2.08911 5.68432C1.35504 6.40445 0.950513 7.36239 0.950488 8.38128C0.950488 9.40015 1.35504 10.3581 2.08909 11.0782C3.60411 12.5647 6.06889 12.5647 7.58416 11.0782L7.54915 11.0425L7.58416 11.0782L12.2344 6.51594Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.1"
    />
  </svg>
);

export default SvgComponent;
